import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=ec52834c&scoped=true"
import script from "./ImageComponent.vue?vue&type=script&lang=js"
export * from "./ImageComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&id=ec52834c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec52834c",
  null
  
)

export default component.exports